(ns manage.content-configuration-page.context-source.dsp-signal
  (:require [common.ui.list :as ui.list]
            [manage.content-configuration-page.context-source.shared :as cs]
            [manage.content-configuration-page.view.input :as view.input]
            [manage.content-configuration-page.view.list :as lv]
            [re-frame.core :as rf]
            [re-posh.core :as rp]
            [uix.core :refer [$]]))

(def schema-id "urn:lemonpi:schema:context:dsp-signal:v1")

;; database

(defn dsp-signal
  [dscs name dsp-macro]
  {:dsp-signal/name name
   :dsp-signal/dsp-macro (or dsp-macro "")
   ;; setting :dsp-signal/owner-id is a workaround for not being able to
   ;; use :dsp-signal-context-source/_signal in a tuple attribute
   :dsp-signal/owner-id dscs})

(rp/reg-event-ds :dsp-signal/create
  (fn [_ [_ dscs name]]
    [{:db/id dscs :dsp-signal-context-source/signal
      [(dsp-signal dscs name nil)]}]))

(defmethod cs/parameter schema-id
  [{signals :dsp-signal-context-source/signal}]
  (map (fn [{:dsp-signal/keys [name dsp-macro]}]
         {:name name
          :dsp-macro dsp-macro})
       signals))

(defmethod cs/context->constructor schema-id
  [{:keys [alias param]}]
  {:dsp-signal-context-source/signal
   (map (fn [{:keys [name dsp-macro]}]
          (dsp-signal [:context-source/alias alias] name dsp-macro))
        param)})

;; UI

(defn dsp-macro [s]
  [view.input/input-save-on-blur
   (merge
    (view.input/props-entity s :dsp-signal/dsp-macro)
    {:form-field-props {:label "DSP macro"}
     :control-props {:disabled @(rf/subscribe [:resource.content-function-version/active-version? "published"])}
     :validation/stages #{:warning}})])

(defn entity-view-cfg-dsp-signal [s]
  {:entity/ref s
   :entity/label :dsp-signal/name
   :entity/icon "code"
   :list-item/details [dsp-macro s]})

(defmethod cs/entity-view-cfg schema-id
  [dscs]
  (merge
   (cs/entity-view-cfg-base dscs)
   {:list-item/details [cs/configure-button dscs "code" "Configure DSP macros"]
    :entity/content
    [lv/view
     {:entity/ref dscs
      :list/add-item-cfg
      {:add-item/label "Add DSP macro"
       :validation/schema :dsp-signal/name
       :add-item/new-value [:add-item/suggest-name :dsp-signal/name "signal"]
       :add-item/add-fn #(rf/dispatch [:dsp-signal/create (:eid dscs) %])}
      :list/items :dsp-signal-context-source/signal
      :list/->item-cfg entity-view-cfg-dsp-signal
      :list/empty-msg ($ ui.list/empty-msg {:title "Define DSP-specific macros"}
                         ($ :p
                            "For each targeting key, define the DSP macro specific to the DSP you are using.")
                         ($ :p
                            "The DSP will replace the macro when requesting content,
                             such that the DSP substituted value can be used in the
                             content enrichment process."))}]}))

(defmethod cs/entity-query-params schema-id
  [{:keys [alias]}]
  (cs/alias->entity-query-params alias))
